<template>
    <PendingPayments></PendingPayments>
</template>
<script>
    import PendingPayments from '@/components/PendingPaymentLiquidations.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            PendingPayments
        }
    }
</script>